// client/src/utils/authedFetch.js
// Wrapper around fetch() that attaches the current user's Firebase ID token.
// Use for all admin endpoints and member-scoped endpoints (e.g. manageSubscription).
import { auth } from '../firebase';

export async function authedFetch(url, options = {}) {
  const user = auth.currentUser;
  if (!user) throw new Error('Not signed in');
  const token = await user.getIdToken();
  return fetch(url, {
    ...options,
    headers: {
      ...(options.headers || {}),
      Authorization: `Bearer ${token}`,
    },
  });
}
